import { render, staticRenderFns } from "./ProgressShimmer.vue?vue&type=template&id=6efe7f15&"
import script from "./ProgressShimmer.vue?vue&type=script&lang=js&"
export * from "./ProgressShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports